import { Box, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { ApiYTDReport } from '../../apiService/Core/Apicall';
import { toast } from 'react-toastify';
import Domains from '../../global/constants/domain';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import storage from '../../utils/storage';

const getIconColorByDomain = () => {
    const domain = window.location.hostname;

    if (domain.includes(Domains.ALDI)) return '#001F79';
    if (domain.includes(Domains.BLOOMS)) return '#1C2B90';
    if (domain.includes(Domains.MM)) return '#ADB792';

    return '#ADB792';
};
const primary_color = getIconColorByDomain()


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: primary_color,
        color: theme.palette.common.white,
        padding: "10px 20px"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: " 10px 20px",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: `${primary_color}1A`,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

function YTDReport() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));
    const [monthList, setMonthList] = useState<any>([]);
    const [YTDReport, setYTDReport] = useState<any>([]);
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)


    useEffect(() => {
        const getMonthRange = (start: any, end: any) => {
            const startDate = new Date(start + '-01');
            const endDate = new Date(end + '-01');
            const result = [];

            while (startDate <= endDate) {
                const month = startDate.toLocaleString('en-US', { month: 'short' });
                const year = startDate.getFullYear();
                result.push(`${month}-${year}`);
                startDate.setMonth(startDate.getMonth() + 1);
            }

            return result;
        };

        setMonthList(getMonthRange(`${startMonth.year()}-${startMonth.month() + 1}`, `${endMonth.year()}-${endMonth.month() + 1}`))
    }, [startMonth, endMonth, clientEntity]);

    useEffect(() => {
        const getData = async () => {
            const data = `?s_year=${startMonth.year()}&s_month=${startMonth.month() + 1}&clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&e_year=${endMonth.year()}&e_month=${endMonth?.month() + 1}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
            try {
                const response = await ApiYTDReport(data)
                setYTDReport(response.data)

            } catch (error: any) {
                // toast.error(error)
            }

        }
        getData()
    }, [startMonth, endMonth, clientEntity])
    useEffect(() => {
        setEndMonth(dayjs(selectedMonth))
    }, [selectedMonth])
    return (
        <Box>
            <Box className='d-flex justify-content-end'>
                <Box justifyContent={{ xs: 'start', md: 'end' }} className='col-md-4 col-12 d-flex align-itmes-center'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" width='100%' gap={2}>
                            <DatePicker value={startMonth} className='col'
                                label="Start Month: "
                                views={['month', 'year']}
                                format="MMM-YY"
                                maxDate={endMonth}
                                onChange={(e) => { setStartMonth(e); }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                            <DatePicker value={endMonth} className='col'
                                label="End Month:"
                                views={['month', 'year']}
                                format="MMM-YY"
                                minDate={startMonth}
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </Box>
                    </LocalizationProvider>
                </Box>
            </Box>

            <Box className='mt-5'>
                <Typography className='text-main text-center fw-bold' variant='h4'> Overall Score:{YTDReport?.overallScore ?? 'N/A'}/5</Typography>

                {/* ----------------------------------------------------- Group Report ----------------------------- */}
                <Box className='table'>
                    <Typography className='fw-bold my-2' variant='h6'>Star Rating Performance Report - Group</Typography>
                    <TableContainer component={Paper} sx={{ maxWidth: 'calc(100vw - 220px)' }}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Venue Name</StyledTableCell>
                                    {monthList.map((month: any, index: number) => (
                                        <StyledTableCell key={index} align='center'>{month}</StyledTableCell>
                                    ))}
                                    <StyledTableCell align='center'>Average</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {((YTDReport.starRatingPerformanceReport)?.length > 0) ? (YTDReport?.starRatingPerformanceReport?.map((item: any, index: number) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell >{item?.venueName}</StyledTableCell>
                                        {monthList.map((labelmonths: any, index: number) => {
                                            const formattedScores = item?.score.map((items: any) => {
                                                const date = new Date(items.reportYear, items.reportMonth - 1); // month is 0-based
                                                const formattedDate = date.toLocaleString('en-US', { month: 'short', year: 'numeric' }).replace(' ', '-');
                                                return {
                                                    ...items,
                                                    formattedMonth: formattedDate,
                                                };
                                            });

                                            const matchedCategory = formattedScores?.find(
                                                (month: any) => month.formattedMonth === labelmonths
                                            );

                                            return (
                                                <StyledTableCell align="center" key={index}>
                                                    {matchedCategory ? matchedCategory.avgStarRating : "N/A"}
                                                </StyledTableCell>
                                            );
                                        })}

                                        <StyledTableCell align='center' sx={{ borderLeft: '1px solid black !important' }}>{item?.average}</StyledTableCell>
                                    </StyledTableRow>

                                ))) : <StyledTableRow><StyledTableCell className='text-center' colSpan={monthList.length + 2} sx={{ width: '100%' }}><Typography className='text-center' variant='h5'>No Data Found</Typography></StyledTableCell></StyledTableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* ----------------------------------------------------- Group Report ----------------------------- */}
                <Box className='mt-5'>
                    <Typography className='fw-bold my-2' variant='h6'>Category Comparison Report</Typography>
                    {
                        ((YTDReport.categoryComparisionReport)?.length > 0) ? (YTDReport?.categoryComparisionReport?.map((category: any, index: number) => (
                            <Box className='table'>
                                <Typography className='fw-bold' variant='h6'>{category?.categoryName}</Typography>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Venue Name</StyledTableCell>
                                                {monthList.map((month: any, index: number) => (
                                                    <StyledTableCell key={index} align='center'>{month}</StyledTableCell>
                                                ))}
                                                <StyledTableCell align='center'>Average</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {category?.data?.map((item: any, index: number) => (
                                                <StyledTableRow key={index}>
                                                    <StyledTableCell >{item?.venueName}</StyledTableCell>
                                                    {monthList.map((labelmonths: any, index: number) => {
                                                        const formattedScores = item?.reportData?.map((items: any) => {
                                                            const date = new Date(items.reportYear, items.reportMonth - 1); // month is 0-based
                                                            const formattedDate = date.toLocaleString('en-US', { month: 'short', year: 'numeric' }).replace(' ', '-');
                                                            return {
                                                                ...items,
                                                                formattedMonth: formattedDate,
                                                            };
                                                        });

                                                        const matchedCategory = formattedScores?.find(
                                                            (month: any) => month.formattedMonth === labelmonths
                                                        );

                                                        return (
                                                            <StyledTableCell align="center" key={index}>
                                                                {matchedCategory ? matchedCategory.score : "N/A"}
                                                            </StyledTableCell>
                                                        );
                                                    })}

                                                    <StyledTableCell align='center' sx={{ borderLeft: '1px solid black !important' }}>{parseFloat(item?.avgScore).toFixed(2)}</StyledTableCell>
                                                </StyledTableRow>

                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>


                        ))) : <Typography className='text-center' variant='h5'>No Data Found</Typography>}
                </Box>

            </Box>
        </Box>
    )
}

export default YTDReport
